import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _defineProperty from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/defineProperty";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.object.keys.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Logger from 'js-logger';
import cloneDeep from 'lodash/cloneDeep';
import Vue from 'vue';
import { make } from 'vuex-pathify';
import { FIB } from '@/config/constants';
var MAX_PASSCODE_LENGTH = FIB.MAX_PASSCODE_LENGTH,
    MIN_PASSCODE_LENGTH = FIB.MIN_PASSCODE_LENGTH;

var defaultState = function defaultState() {
  return {
    teamData: {
      teamMembers: [],
      teamListings: []
    }
  };
};

var state = defaultState();

var actions = _objectSpread(_objectSpread({}, make.actions(state)), {}, {
  // Make default actions

  /**
   * Fetch single team member's data and store or show error.
   *
   * @param {Object} context Vuex module context
   * @param {Number} id Team Member ID
   *
   * @returns {Boolean} True on success, false otherwise
   */
  fetchTeamMember: function fetchTeamMember(_ref, id) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var commit, res;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;

              if (!id) {
                _context.next = 12;
                break;
              }

              _context.next = 4;
              return _this.$api.fetchTeamMember(id);

            case 4:
              res = _context.sent;

              if (res && res.data && res.data.staff) {
                _context.next = 8;
                break;
              }

              Logger.error('no staff member returned from call');
              return _context.abrupt("return");

            case 8:
              commit('setTeamMember', res.data.staff);
              return _context.abrupt("return", true);

            case 12:
              Logger.warn('fetchTeamMember requires id to be set');

            case 13:
              Logger.error('failed to add team member');
              return _context.abrupt("return", false);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },

  /**
   * Fetch team member data and store or show error.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True on success, false otherwise
   */
  fetchTeamMembers: function fetchTeamMembers(_ref2) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var commit, rootState, id, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit, rootState = _ref2.rootState;
              id = rootState.config.branchId;

              if (!id) {
                _context2.next = 11;
                break;
              }

              _context2.next = 5;
              return _this2.$api.fetchTeamMembers(id);

            case 5:
              res = _context2.sent;

              if (!res) {
                _context2.next = 9;
                break;
              }

              commit('setTeamMembers', res);
              return _context2.abrupt("return", true);

            case 9:
              _context2.next = 12;
              break;

            case 11:
              Logger.warn('fetchTeamMembers requires branchId to be set');

            case 12:
              return _context2.abrupt("return", false);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },

  /**
   * Add new team member and store or show error.
   *
   * @param {Object} context Vuex module context
   * @param {Object} member Team member data
   *
   * @returns {Boolean} True on success, false otherwise
   */
  addTeamMember: function addTeamMember(_ref3, member) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit, dispatch, res;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit, dispatch = _ref3.dispatch;

              if (!member) {
                _context3.next = 14;
                break;
              }

              _context3.next = 4;
              return _this3.$api.addTeamMember(member);

            case 4:
              res = _context3.sent;

              if (!(res && !res.error)) {
                _context3.next = 13;
                break;
              }

              if (res.data && res.data.id) {
                _context3.next = 9;
                break;
              }

              Logger.error('no id returned from api call');
              return _context3.abrupt("return");

            case 9:
              member.id = res.data.id;
              commit('addTeamMember', member); // TODO: Remove when the API starts returning up to date data // ******

              dispatch('fetchTeamMember', member.id);
              return _context3.abrupt("return", true);

            case 13:
              Logger.error('status not ok', res);

            case 14:
              Logger.error('failed to update team member');
              return _context3.abrupt("return", false);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },

  /**
   * Update team member data and store or show error.
   *
   * @param {Object} context Vuex module context
   * @param {Object} member Team member data
   *
   * @returns {Boolean} True on success, false otherwise
   */
  updateTeamMember: function updateTeamMember(_ref4, member) {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var commit, dispatch, res;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit, dispatch = _ref4.dispatch;

              if (!member) {
                _context4.next = 10;
                break;
              }

              _context4.next = 4;
              return _this4.$api.updateTeamMember(member);

            case 4:
              res = _context4.sent;

              if (!(res && res && !res.error)) {
                _context4.next = 9;
                break;
              }

              commit('setTeamMember', member); // TODO: Remove when the API starts returning up to date data // ******

              dispatch('fetchTeamMember', member.id);
              return _context4.abrupt("return", true);

            case 9:
              Logger.error('status not ok', res);

            case 10:
              Logger.error('failed to update team member');
              return _context4.abrupt("return", false);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }))();
  },

  /**
   * Delete team member data and store or show error.
   *
   * @param {Object} context Vuex module context
   * @param {Object} member Team member data
   *
   * @returns {Boolean} True on success, false otherwise
   */
  deleteTeamMember: function deleteTeamMember(_ref5, member) {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var commit, res;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;

              if (!member) {
                _context5.next = 9;
                break;
              }

              _context5.next = 4;
              return _this5.$api.deleteTeamMember(member);

            case 4:
              res = _context5.sent;

              if (!(res && !res.error)) {
                _context5.next = 8;
                break;
              }

              commit('deleteTeamMember', member);
              return _context5.abrupt("return", true);

            case 8:
              Logger.error('status not ok', res);

            case 9:
              Logger.error('failed to delete team member');
              return _context5.abrupt("return", false);

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  },

  /**
   * Fetch team listings data and store or show error.
   *
   * @param {Object} context Vuex module context
   *
   * @returns {Boolean} True on success, false otherwise
   */
  fetchTeamListings: function fetchTeamListings(_ref6) {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var commit, rootState, id, res;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit, rootState = _ref6.rootState;
              id = rootState.config.branchId;

              if (!id) {
                _context6.next = 11;
                break;
              }

              _context6.next = 5;
              return _this6.$api.fetchTeamListings(id);

            case 5:
              res = _context6.sent;

              if (!(res && !res.error)) {
                _context6.next = 9;
                break;
              }

              commit('setTeamListings', res);
              return _context6.abrupt("return", true);

            case 9:
              _context6.next = 12;
              break;

            case 11:
              Logger.warn('fetchTeamListings requires branchId to be set');

            case 12:
              return _context6.abrupt("return", false);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
});

var getters = _objectSpread(_objectSpread({}, make.getters(state)), {}, {
  // Make default getters

  /**
   * Get team member from id.
   *
   * @param {Object} state Vuex module state
   * @param {String} id Team member id
   *
   * @returns {Object|null} Team member object or null
   */
  getMemberFromId: function getMemberFromId(state) {
    return function (id) {
      return cloneDeep(state.teamData.teamMembers.find(function (member) {
        return member.id === id;
      }) || null);
    };
  },

  /**
   * Get team member from pin.
   *
   * @param {Object} state Vuex module state
   * @param {String} pin PIN
   *
   * @returns {Object|null} Team member object or null
   */
  getMemberFromPin: function getMemberFromPin(state) {
    return function (pin) {
      return cloneDeep(state.teamData.teamMembers.find(function (member) {
        return member.pinCode === pin;
      }) || null);
    };
  },

  /**
   * Has at least one active team member with a pin code and access to settings
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Boolean} At least one active team member with a pin code and access to settings
   */
  hasActiveSettingsTeamMember: function hasActiveSettingsTeamMember(state) {
    return state.teamData.teamMembers.filter(function (member) {
      return member.pinCode && member.pinCode.length >= MIN_PASSCODE_LENGTH && member.pinCode.length <= MAX_PASSCODE_LENGTH && member.hasSettingsAccess && member.status;
    }).length > 0;
  },

  /**
   * Has at least one active team member with a pin code
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Boolean} At least one active team member with a pin code
   */
  hasActiveTeamMember: function hasActiveTeamMember(state) {
    return state.teamData.teamMembers.filter(function (member) {
      return member.pinCode && member.pinCode.length >= MIN_PASSCODE_LENGTH && member.pinCode.length <= MAX_PASSCODE_LENGTH && member.status;
    }).length > 0;
  },

  /**
   * Returns an array containing all currently accessible team member pins.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array} Aray of team member pin codes
   */
  pins: function pins(state) {
    return state.teamData.teamMembers.map(function (member) {
      return member.pinCode;
    });
  },

  /**
   * Returns an array containing all currently active team members ordered by weight.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Array} Aray of team members
   */
  teamMembersOrderedByWeight: function teamMembersOrderedByWeight(state) {
    return cloneDeep(state.teamData.teamMembers.filter(function (member) {
      return member.status === 1;
    })).sort(function (a, b) {
      if (a.weight === b.weight) {
        return 0;
      }

      return a.weight < b.weight ? 1 : -1;
    });
  }
});

var mutations = _objectSpread(_objectSpread({}, make.mutations(state)), {}, {
  // Make default mutations

  /**
   * Reset the module state back to its default.
   *
   * @param {Object} state Vuex module state
   *
   * @returns {Void}
   */
  resetState: function resetState(state) {
    Object.assign(state, defaultState());
  },

  /**
   * Set team members.
   *
   * @param {Object} state Vuex module state
   * @param {Object} payload Team members
   *
   * @returns {Void}
   */
  setTeamMembers: function setTeamMembers(state, payload) {
    var staff = payload && payload.data && payload.data.staff ? payload.data.staff : null;

    if (staff) {
      Vue.set(state.teamData, 'teamMembers', staff);
    }
  },

  /**
   * Set team member data.
   *
   * @param {Object} state Vuex module state
   * @param {Object} member Team member data
   *
   * @returns {Void}
   */
  setTeamMember: function setTeamMember(state, member) {
    var index = state.teamData.teamMembers.findIndex(function (item) {
      return item.id === member.id;
    });

    if (index === -1) {
      return;
    } // JR TODO: // when api is finished, make sure objects match up then refactor to just splice
    // in member, e.g.,
    // state.teamData.teamMembers.splice(index, 1, member)


    var keys = Object.keys(member);
    var newMember = state.teamData.teamMembers[index];

    for (var i in keys) {
      var key = keys[i];
      newMember[key] = member[key];
    }

    state.teamData.teamMembers.splice(index, 1, newMember);
  },

  /**
   * Add team member data.
   *
   * @param {Object} state Vuex module state
   * @param {Object} member Team member data
   *
   * @returns {Void}
   */
  addTeamMember: function addTeamMember(state, member) {
    if (!(member && state.teamData && Array.isArray(state.teamData.teamMembers))) {
      return;
    }

    var newArr = cloneDeep(state.teamData.teamMembers);
    newArr.push(member);
    Vue.set(state.teamData, 'teamMembers', newArr);
  },

  /**
   * Delete team member data.
   *
   * @param {Object} state Vuex module state
   * @param {Object} member Team member data
   *
   * @returns {Void}
   */
  deleteTeamMember: function deleteTeamMember(state, member) {
    var index = state.teamData.teamMembers.findIndex(function (item) {
      return item.id === member.id;
    });

    if (index === -1) {
      return;
    }

    state.teamData.teamMembers.splice(index, 1);
  },
  setTeamListings: function setTeamListings(state, payload) {
    if (((payload || {}).data || {}).items) {
      Vue.set(state.teamData, 'teamListings', payload.data.items);
    }
  }
});

export default {
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations,
  namespaced: true
};